import React, { useEffect, useState } from 'react';
import { apiHolder } from 'api';
const systemApi = apiHolder.api.getSystemApi();
const Text = () => {
    const [dateDay, setDateDay] = useState(new Date().getDate());
    useEffect(() => {
        const t = systemApi.intervalEvent({
            handler: () => {
                setDateDay(new Date().getDate());
            },
            eventPeriod: 'extLong',
            seq: 0,
        });
        return () => {
            if (t !== undefined) {
                systemApi.cancelEvent('extLong', t);
            }
        };
    }, []);
    return (React.createElement("span", { className: "time-text", style: { userSelect: 'none' } }, dateDay));
};
const CalenderSvg = () => (React.createElement("span", { className: "sirius-icon sirius-icon-schedule" },
    React.createElement(Text, null)));
CalenderSvg.Enhance = () => (React.createElement("span", { className: "sirius-icon sirius-icon-schedule sirius-icon-schedule-enhance" },
    React.createElement(Text, null)));
export default CalenderSvg;
